import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Target, Zap, Users, Binary, BrainCircuit } from 'lucide-react';

const StatsScroller = () => {
  const statsData = [
    { id: 1, value: "100+", label: "Audits Réalisés", icon: ShieldCheck },
    { id: 2, value: "15+", label: "Experts Certifiés", icon: Target },
    { id: 3, value: "500+", label: "Menaces Bloquées", icon: Zap },
    { id: 4, value: "99%", label: "Taux de Rétention", icon: Users },
    { id: 5, value: "10B+", label: "Failles Détectées", icon: Binary },
    { id: 6, value: "24/7", label: "Surveillance Active", icon: BrainCircuit }
  ];

  const loopData = [...statsData, ...statsData, ...statsData]; // Triplé pour une fluidité totale

  const scrollerAnimation = {
    animate: {
      x: ["0%", "-33.33%"], // On décale d'un tiers puisque les données sont triplées
      transition: {
        x: {
          repeat: Infinity,
          repeatType: "loop",
          duration: 30, 
          ease: "linear",
        },
      },
    },
  };

  return (
    <section className="w-full bg-[#F6FAFD] py-16 overflow-hidden border-y border-[#B3CFE5]/20">
      <div className="relative w-full">
        
        {/* On a retiré les div de gradients absolute ici */}

        <motion.div 
          className="flex whitespace-nowrap gap-12 items-center"
          variants={scrollerAnimation}
          animate="animate"
        >
          {loopData.map((stat, index) => {
            const IconComponent = stat.icon;
            return (
              <div 
                key={`${stat.id}-${index}`}
                className="flex items-center gap-12"
              >
                {/* Icône Minimaliste */}
                <div className="text-[#4A7FA7] opacity-60">
                    <IconComponent size={24} strokeWidth={1.5}/>
                </div>

                {/* Bloc Stats */}
                <div className="flex flex-col">
                  <span className="text-[#0A1931] text-[32px] md:text-[36px] font-black leading-none mb-1 font-inter">
                    {stat.value}
                  </span>
                  <span className="text-[#0A1931] text-[11px] md:text-[12px] font-bold uppercase tracking-[0.2em] opacity-60 font-inter text-left">
                    {stat.label}
                  </span>
                </div>

                {/* Séparateur Vertical Ultra-fin */}
                <div className="h-10 w-[1px] bg-[#B3CFE5]/30 ml-4" />
              </div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};

export default StatsScroller;